import { SeverityIcon } from "@/features/schedule-notes/components/severity-icon";
import {
	SEVERITIES,
	SEVERITY_LABELS,
} from "@/features/schedule-notes/utils/severity.ts";
import { HUE_COUNT, type ColorScheme, type Tone } from "../../utils/colors.ts";

const STATUS_ENTRIES: { tone: Tone; label: string }[] = [
	{ tone: "branch", label: "Etapa pai" },
	{ tone: "pending", label: "Pendente" },
	{ tone: "in_progress", label: "Em andamento" },
	{ tone: "completed", label: "Concluída" },
	{ tone: "delayed", label: "Atrasada" },
	{ tone: "cancelled", label: "Cancelada" },
];

export function GanttLegend({
	scheme,
	topLevelNames,
}: {
	scheme: ColorScheme;
	topLevelNames: string[];
}) {
	const entries =
		scheme === "status"
			? STATUS_ENTRIES
			: [
					...topLevelNames.slice(0, HUE_COUNT).map((name, index) => ({
						tone: `hue-${index + 1}` as Tone,
						label: name,
					})),
					{ tone: "delayed" as Tone, label: "Atrasada" },
				];

	return (
		<div className="schedule-gantt__legend" data-testid="gantt-legend">
			{entries.map((entry) => (
				<span key={entry.tone} className="schedule-gantt__legend-item">
					<span className="schedule-gantt__swatch" data-tone={entry.tone} />
					{entry.label}
				</span>
			))}
			<span className="schedule-gantt__legend-item">
				<span className="schedule-gantt__swatch is-hatch" data-tone="pending" />
				Previsto restante
			</span>
			<span className="schedule-gantt__legend-item">
				<span className="schedule-gantt__swatch is-actual" />
				Realizado
			</span>
			<span className="schedule-gantt__legend-item">
				<span className="schedule-gantt__swatch is-extension" />
				Atraso até hoje
			</span>
			<span className="schedule-gantt__legend-item">
				<span className="schedule-gantt__swatch is-today" />
				Hoje
			</span>
			{SEVERITIES.map((severity) => (
				<span key={severity} className="schedule-gantt__legend-item">
					<SeverityIcon
						severity={severity}
						className="schedule-gantt__legend-icon"
					/>
					{SEVERITY_LABELS[severity]}
				</span>
			))}
		</div>
	);
}
